//* HOCs
import withUIContext from 'context/consumerHOC/UIConsumer'

//* Components
import Page from 'components/common/Page'
import Text from 'components/common/Text'
import Image from 'components/common/Image'
import TitleTextComp from 'components/pages/About/TitleTextComp'

//* Style
import AboutUsStyle from 'styles/pages/AboutUsStyle'

const AboutUs = ({ winWidth }) => {
    return (
        <AboutUsStyle>
            <Page className={'about-us flexBoxColumn alignMiddle'}>
                <TitleTextComp
                    title={'Our Story'}
                    subtitle={'Our journey started after the 11th senseless and ineffective meeting on the same topic'}
                    content={'We wanted to buy a coffee machine for our office. At first we opened a WhatsApp chat, later organized a Slack voting, then a Zoom call, and another call, and another call and yes, you are right, another call. On November 2020 we decided to create the OPLOS: a tool that can ease the life of people who like having productive debate and make efficient & structured decisions. Now we are sitting next to our coffee machine, with an aim to turn OPLOS into the best decision-making tool for individuals and teams.'}
                />
                <TitleTextComp
                    title={'Our Mission'}
                    subtitle={'By giving everyone an opportunity to share standpoints we want to make research conduction accessible.'}
                    content={'We’re building a debating platform for customer oriented product development process. By giving users an interactive platform for debating we’re making it accessible for researched to use secondary data from real users.'}
                />
                <div className='our-team flexBoxColumn alignMiddle sectionMarginBottom'>
                    <Text tag={'p'} className={'titleMarginBottom NewYork h1'} text={'Our Team'} />
                    <Text tag={'h3'} className={'subtitleMarginBottom h3 PopReg'}
                        text={'Our team is customer-obsessed, mission-oriented, and believes anything is possible.'} />
                    <div className='team flexBox'>
                        <div className='single-member flexBoxColumn alignMiddle'>
                            <Image src='/images/about/arshakkarapetyan.webp' />
                            <Text tag={'h4'} className={'name h4 PopSemi'} text={'Arshak Karapetyan'} />
                            <Text tag={'h5'} className={'role darkGrey h5 PopReg'} text={'Co-Founder, CEO'} />
                        </div>
                        <div className='single-member flexBoxColumn alignMiddle'>
                            <Image src='/images/about/annaavanesyan.webp' />
                            <Text tag={'h4'} className={'name h4 PopSemi'} text={'Anna Avanesyan'} />
                            <Text tag={'h5'} className={'role darkGrey h5 PopReg'} text={'Co-Founder, CTO'} />
                        </div>
                        <div className='single-member flexBoxColumn alignMiddle'>
                            <Image src='/images/about/hovhannesyeritsyan.webp' />
                            <Text tag={'h4'} className={'name h4 PopSemi'} text={'Hovhannes Yeritsyan'} />
                            <Text tag={'h5'} className={'role darkGrey h5 PopReg'} text={'Co-Founder, CCO'} />
                        </div>
                        <div className='single-member flexBoxColumn alignMiddle'>
                            <Image src='/images/about/hasmikzmoyan.webp' />
                            <Text tag={'h4'} className={'name h4 PopSemi'} text={'Hasmik Zmoyan'} />
                            <Text tag={'h5'} className={'role darkGrey h5 PopReg'} text={'Co-Founder, CMO'} />
                        </div>
                    </div>
                </div>
                <TitleTextComp
                    title={'About Solution'}
                    content={'We are purpose-driven people, dedicated to serving something beyond ourselves. Having mission as a value also allows us to continually ground ourselves in why we’re building Oplos.'}
                />
                {winWidth > 601 ?
                    <div className='solution flexBox'>
                        <div className='sols flexBoxColumn'>
                            <div className='single-solution flexBox sectionMarginBottom'>
                                <Image src='/images/debateCard.webp' />
                                <div className={'info'}>
                                    <Text tag={'h3'} className={'subtitleMarginBottom h3 PopSemi'}
                                        text={'Debate anything from anywhere'} />
                                    <Text tag={'h4'} className={'h4 PopReg'}
                                        text={"Oplos for public is a debating platform for anyone to discuss the most trendy and questionable topics. Every individual can state his own opinion and share with our global community, find supporters or defend the viewpoint."} />
                                </div>
                            </div>
                            <div className='single-solution flexBox sectionMarginBottom'>
                                <Image src='/images/about/hostDebates.webp' />
                                <div className='info'>
                                    <Text tag={'h3'} className={'subtitleMarginBottom h3 PopSemi'}
                                        text={'Host private debates'} />
                                    <Text tag={'h4'} className={'h4 PopReg'}
                                        text={'Our private debate creation tool allows you to use all oplos functionality and host a debate only accesible for limited people you’ve chosen.Invitations can only be sent to people who follow your oplos profile.'} />
                                </div>
                            </div>
                            <div className='single-solution flexBox sectionMarginBottom'>
                                <Image src='/images/about/enterprise.webp' />
                                <div className='info'>
                                    <Text tag={'h3'} className={'subtitleMarginBottom h3 PopSemi'}
                                        text={'Oplos for enterprise is coming soon'} />
                                    <Text tag={'h4'} className={'h4 PopReg'}
                                        text={'Oplos for enterprise is a SaaS platform to help the teams to systemize the decision making process and customize priorities. All 4 steps of decision making process are designed to help companies to reach the most democratic and suitable decision in a short period of time.'} />
                                </div>
                            </div>
                        </div>
                    </div>
                    :
                    <div className='solution flexBox'>
                        <div className='sols flexBoxColumn'>
                            <Image src='/images/debateCard.webp' />
                            <div className='single-solution flexBoxColumn sectionMarginBottom'>
                                <Text tag={'h3'} className={'subtitleMarginBottom h3 PopSemi'}
                                    text={'Debate anything from anywhere'} />
                                <Text tag={'h4'} className={'h4 PopReg'}
                                    text={"Oplos for public is a debating platform for anyone to discuss the most trendy and questionable topics. Every individual can state his own opinion and share with our global community, find supporters or defend the viewpoint."} />
                            </div>
                            <Image src='/images/about/hostDebates.webp' />
                            <div className='single-solution flexBoxColumn sectionMarginBottom'>
                                <Text tag={'h3'} className={'subtitleMarginBottom h3 PopSemi'}
                                    text={'Host private debates'} />
                                <Text tag={'h4'} className={'h4 PopReg'}
                                    text={'Our private debate creation tool allows you to use all oplos functionality and host a debate only accesible for limited people you’ve chosen.Invitations can only be sent to people who follow your oplos profile.'} />
                            </div>
                            <Image src='/images/about/enterprise.webp' />
                            <div className='single-solution flexBoxColumn sectionMarginBottom'>
                                <Text tag={'h3'} className={'subtitleMarginBottom h3 PopSemi'}
                                    text={'Oplos for enterprise is coming soon'} />
                                <Text tag={'h4'} className={'h4 PopReg'}
                                    text={'Oplos for enterprise is a SaaS platform to help the teams to systemize the decision making process and customize priorities. All 4 steps of decision making process are designed to help companies to reach the most democratic and suitable decision in a short period of time.'} />
                            </div>
                        </div>
                    </div>
                }

                {/* <TitleTextComp
				button={ true }
				title={ 'Try it now' }
				content={ 'Create your first debate for now. Share with friends and find out what they and thousands of other users think' }
			  /> */}
            </Page>
        </AboutUsStyle>
    )
}

export default withUIContext(AboutUs, ['winWidth'])
